import React from 'react';

function AccountLocked({ onLogout }) {
  const paymentUrl = process.env.REACT_APP_PAYMENT_URL || 'https://routes-app.com/subscribe';

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8f9fa',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          maxWidth: '480px',
          background: '#fff',
          borderRadius: '16px',
          padding: '2.5rem',
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        }}
      >
        <div style={{ marginBottom: '1.5rem' }}>
          <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#006B01" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>

        <h2 style={{ fontWeight: 700, marginBottom: '0.75rem', color: '#1a1a1a' }}>
          Account Access Ended
        </h2>

        <p style={{ color: '#666', lineHeight: 1.6, marginBottom: '1.5rem' }}>
          Your club membership has ended and your account is currently inactive.
          Subscribe to keep your profile active, stay visible to employers, and
          continue accessing all your Routes content.
        </p>

        <a
          href={paymentUrl}
          style={{
            display: 'block',
            width: '100%',
            padding: '0.875rem',
            background: '#006B01',
            color: '#fff',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: 600,
            fontSize: '1rem',
            marginBottom: '1rem',
          }}
        >
          Subscribe to Continue
        </a>

        <p style={{ fontSize: '0.8rem', color: '#999', marginBottom: '1.5rem' }}>
          After payment your account will be reactivated automatically — just log back in.
        </p>

        <button
          onClick={onLogout}
          style={{
            background: 'none',
            border: 'none',
            color: '#999',
            cursor: 'pointer',
            fontSize: '0.875rem',
            textDecoration: 'underline',
          }}
        >
          Log out
        </button>
      </div>
    </div>
  );
}

export default AccountLocked;
